import styled from 'styled-components'

const Head = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  align-self: stretch;
`

const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const StatsWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  flex: 0 0 auto;
  flex-wrap: wrap;
`

const StatsBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;

  .star-box {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    span {
      color: #8d8d8d;

      leading-trim: both;

      text-edge: cap;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 12px;
    }
  }
`

const StatsBoxTitle = styled.span`
  color: #2c2c2c;

  leading-trim: both;
  text-edge: cap;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  height: 10px;
  white-space: break-spaces;
  word-wrap: break-word;
`

const StatsBoxValue = styled.span`
  color: var(--gray-800, #1a202c);
  text-align: center;
  leading-trim: both;
  text-edge: cap;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
`

const ProgressBar = styled.div`
  display: flex;
  padding: 4px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  border-radius: 999px;
  border: 1px solid var(--colorBorder, rgba(0, 0, 0, 0.15));
  background: #f9f9f9;
  width: 100%;

  .custom-progress {
    display: flex;
    width: ${({ percent }) => (percent < 20 ? 'min-content' : `${percent}%`)};
    height: 40px;
    padding: 8px 16px;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    border-radius: 99px;
    background: var(--Sucess, #34c38f);

    span {
      color: var(--Text-color-Tiitle-light, #fff);
      leading-trim: both;

      text-edge: cap;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 36px;
    }
  }
`
const CustomTitle = styled.div`
  color: #2f2b3d;
  opacity: 0.9;
  font-feature-settings: 'liga' off, 'clig' off;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

const Styles = {
  Head,
  SwitchWrapper,
  StatsWrapper,
  StatsBox,
  StatsBoxTitle,
  StatsBoxValue,
  ProgressBar,
  CustomTitle,
}

export default Styles
